import './VideoDescriptionSkeleton.css';

export default function VideoDescriptionSkeleton() {
	return (
		<div id="video-description-skeleton" className="skeleton">
			<h3 className="skeleton-element" />
			<p>
				<span className="skeleton-element" />
				<span className="skeleton-element" />
				<span className="skeleton-element" />
				<span className="skeleton-element" />
				<span className="skeleton-element" />
				<span className="skeleton-element" />
				<span className="skeleton-element" />
				<span className="skeleton-element" />
			</p>
		</div>
	);
}
